const ABViewFormItemCore = require("../../core/views/ABViewFormItemCore");
module.exports = class ABViewFormItem extends ABViewFormItemCore {};
